import { Box, Button, Modal } from '@mui/material'
import cafgu from '../../../../assets/images/core/cafgu_bg.png'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

export const Cafgu = ({cafguModal, addTour}) => {
    const history = useHistory()
    const handleCnt = () => {
        cafguModal.set(false)
        history.push('/biz/careers/add');
        addTour.set(true)
    };
    
  return (
    
    <Modal
        open={cafguModal.data}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        >
            <Box width='100%' height='100%' display='flex' justifyContent='center' alignItems='center' bgcolor='#000000B3'>
                <Box display='flex' justifyContent='center' width={600} py={6}  borderRadius={4}>
                    <Box width={420}  bgcolor='#fff'  display='flex' flexDirection='column' justifyContent='center' pb={2} gap={2} borderRadius={4}>
                        <Box display='flex' justifyContent='center'> <img src={cafgu} alt ="cafgu" width='100%' height={200}/> </Box>
                        <Box display='flex' flexDirection='column' gap={2}>
                            <Box mx={2} fontSize={16} fontWeight={700} display='flex' justifyContent='center' color='#009E6A'> Extraordinary and Heroic Day!  </Box>
                            <Box>
                                <Box mx={2} fontSize={14} display='flex' fontWeight={400} justifyContent='center'> Before we start, let’s set up your business </Box>
                                <Box mx={2} fontSize={14} display='flex' fontWeight={400} justifyContent='center' gap='4px'>
                                    <Box > account first using  </Box>
                                    <Box fontWeight={700} >  POFCareers Business </Box>
                                </Box>    
                            </Box>
                        </Box>
                        <Box display='flex' justifyContent='center' gap={2} mt={1}>
                            <Box component={Button} borderRadius='8px' bgcolor='#03A36E' color='#fff' width={280} sx={{':hover': {bgcolor:'green'}}} onClick={handleCnt}> Get Started</Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
    </Modal>
  )
}
